import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function removeDiscount(token,params){
    return Api.delete(REQUEST_URLS.AUTHENTICATION.REMOVE_DISCOUNT,{
        params,
        headers:{
            "Authorization": `Bearer ${token}`
        }
    })
}
export default removeDiscount;